<template>
  <a :href="href" class="link">
    <span class="link">
      <slot />
    </span>
    <span class="link__arrow">
      &#8250;
    </span>
  </a>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    href: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  &__arrow {
    font-size: 130%;
    line-height: .7;
    margin-left: 8px;
  }
}
</style>
